module.exports = __webpack_public_path__ + "img/spalteloeschen.137dfa4.svg";